module.exports = "https://static.wmbcdn.com/uniweb/images/e38af8dd10f0ed69670af344f4b9d968.svg";